import { IPatient, IParaclinical } from "../models/MakeAnAppointmentModels";

export const initialValuesPatient: IPatient = {
    person: {
        fullName: "",
        firstName: "",
        lastName: "",
        displayName: "",
        shortName: "",
        otherName: "",
        birthDate: "",
        birthPlace: "",
        dobDay: "",
        dobMonth: "",
        dobYear: "",
        gender: null,
        startDate: "",
        endDate: "",
        phoneNumber: "",
        idNumber: "",
        email: "",
        taxCode: "",
        ccountry: null,
        appointmentDate: ""
    },
    personCode: "",
    personName: "",
    allergyStatus: "text",
    code: "",
    ethnicity: null,
    phoneNumber: "",
    gender: "",
    idNumber: "",
    address: null,
    administrativeUnit: null,
    province: null,
    district: null,
    commune: null,
    occupation: null,
    appointmentDate: null,
    referrer: null,
    deleted: false,
    deletedBy: null,
    deletedDate: null,
    deletedReason: null
};

export const UU_TIEN = {
    TRUE: 0,
    FALSE: 1
};

export const initialValuesParaclinical: IParaclinical = {
    patient: initialValuesPatient,
    indicationPerson: "",
    requestDeptName: "",
    visit: {
        visitObjectType: null,
        visitType: null,
        visitReason: '',
        serviceType: null,
        dept: null,
        attributes:null,
        sortWeight: UU_TIEN.FALSE,
    },
    ordersAndDiagnosis: {
        ordersDto: []
      },
};